import * as React from "react";
import { memo } from "react";
const SvgPositionCardBg = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 382, height: 102, viewBox: "0 0 382 102", fill: "none", ...props }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("path", { d: "M372 20L365.053 9.02941L10.371 6.5L6 74.2941L18.0231 91.5L365.053 86.6471L372 20Z", fill: "#011936" })));
const Memo = memo(SvgPositionCardBg);
export default Memo;
